import React, { Fragment, useState, useEffect, useCallback } from "react";
import Breadcrumb from "../../common/breadcrumb";
import { Card, CardBody, Container, Row } from "reactstrap";
import { Button } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import { ArrowBack } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import {
  vendorRegistrationHistoryTableData,
  vendorRegistrationHistoryTableHeader,
} from "../../common/commonConstantAp";
import { getAllVendorRegistrationHistory } from "../../api/ap_services";
import CommonLoader from "../../common/commonLoader";
import { useLocation, useNavigate } from "react-router-dom";
import CommonTableAp from "../../common/commonTableAp";

const useStyles = makeStyles((theme) => ({
  cardbody: {
    padding: `${theme.spacing(1.8, 1.3)} !important`,
    [theme.breakpoints.down("sm")]: {
      padding: `${theme.spacing(0)} !important`,
      margin: `${theme.spacing(0, 1)} !important`,
    },
  },
  backRow: {
    marginBottom: theme.spacing(1),
  },
}));

const VendorRegistrationHistory = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();

  const vendorRegistrationId =
    location?.state?.vendorRegistrationIdParam ??
    location?.state?.vendorRegistrationId;

  const [totalRecord, setTotalRecord] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadListData = useCallback(() => {
    if (vendorRegistrationId == null || vendorRegistrationId === "") {
      setData([]);
      setTotalRecord(0);
      return;
    }
    setLoading(true);
    getAllVendorRegistrationHistory(page, rowsPerPage, vendorRegistrationId)
      .then((res) => {
        setLoading(false);
        const raw = res?.response?.responseObject ?? [];
        setData(Array.isArray(raw) ? raw : []);
        setTotalRecord(res?.response?.responseMap?.totalCount ?? 0);
      })
      .catch(() => {
        setLoading(false);
        toast.error("Failed to load vendor registration history.");
      });
  }, [vendorRegistrationId, page, rowsPerPage]);

  useEffect(() => {
    loadListData();
  }, [loadListData]);

  useEffect(() => {
    if (vendorRegistrationId == null || vendorRegistrationId === "") {
      toast.error("Vendor registration is not selected.");
    }
  }, [vendorRegistrationId]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };

  const goBackToList = () => {
    navigate(`${process.env.PUBLIC_URL}/master/vendorRegistrationList`);
  };

  return (
    <Fragment>
      {loading ? <CommonLoader /> : null}
      <Breadcrumb
        title="Vendor Registration History"
        parent={
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              color="secondary"
              variant="contained"
              startIcon={<ArrowBack />}
              onClick={goBackToList}
              size="small"
            >
              Back to list
            </Button>
          </div>
        }
      />

      <Container fluid={true}>
        <Row className={classes.backRow} />
        <Row>
          <Card>
            <CardBody className={classes.cardbody}>
              {data.length === 0 ? (
                <div style={{ textAlign: "center", padding: "20px" }}>
                  No data found.
                </div>
              ) : (
                <CommonTableAp
                  tableData={data}
                  tableHeaders={vendorRegistrationHistoryTableHeader}
                  tableColumns={vendorRegistrationHistoryTableData}
                  editId={"vendorRegistrationListId"}
                  editMode={false}
                  rowsPerPageOptions={[25, 50, 100]}
                  count={totalRecord}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  sx={{ float: "right" }}
                  showHistory={false}
                  showPdf={false}
                  showTimeStamp
                  stripedRows={true}
                />
              )}
            </CardBody>
          </Card>
        </Row>
      </Container>
      <ToastContainer autoClose={2000} />
    </Fragment>
  );
};

export default VendorRegistrationHistory;
